import React from 'react'
import PropTypes from 'prop-types'

import { CheckoutSection } from '../../components'
import { notifyError } from '../UserMessaging'
import { Fade } from '../../componentAnimations'

import isEqual from 'lodash/isEqual'
import { translateResourceString } from '../../../util/translationUtility';
import { Tooltip } from '../../components/tooltip/Tooltip'


const placeOrderDetailsChanged = (prevProps, newProps) => !isEqual(prevProps.Coupons, newProps.Coupons) || !isEqual(prevProps.CartItems, newProps.CartItems) || !isEqual(prevProps.SelectedShippingOptionId, newProps.SelectedShippingOptionId);


class CheckoutCoupon extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            isCollapsed: !!!this.props.isExpanded,
            newCouponCode: this.props.isExpanded && this.props.Coupons.length > 0 ? this.props.Coupons[0].Code : '',
            currentCouponCode: this.props.isExpanded && this.props.Coupons.length > 0 ? this.props.Coupons[0].Code : ''
        };
    }

    onClickChange(e) {
        e.preventDefault();
        this.setState({ isCollapsed: !this.state.isCollapsed });
    }

    onKeyPress(e) {
        if (e.key === "Enter") {
            this.addCoupon();
        }
    }

    addCoupon() {
        if (this.state.newCouponCode && this.state.newCouponCode != '') {
            this.props.onAddCoupon(this.state.newCouponCode);
            this.setState({ newCouponCode:  this.props.isExpanded && this.props.Coupons.length > 0 ? this.props.Coupons[0].Code : '',
                currentCouponCode: this.props.isExpanded && this.props.Coupons.length > 0 ? this.props.Coupons[0].Code : '' });
        } else {
            alert(translateResourceString("/Checkout/Coupons/NoPromotionCodeEntered"));
        }
    }

    removeCoupon(code) {
        if (code && code != '') {
            this.props.onRemoveCoupon(code);
            this.setState({ newCouponCode:  this.props.isExpanded && this.props.Coupons.length > 0 ? this.props.Coupons[0].Code : '',
                currentCouponCode: this.props.isExpanded && this.props.Coupons.length > 0 ? this.props.Coupons[0].Code : '' });
        }
    }

    componentDidUpdate(prevProps) {
        if (placeOrderDetailsChanged(prevProps, this.props)) {
            this.props.updateCoupons();
            this.setState({ newCouponCode:  this.props.isExpanded && this.props.Coupons.length > 0 ? this.props.Coupons[0].Code : '',
            currentCouponCode: this.props.isExpanded && this.props.Coupons.length > 0 ? this.props.Coupons[0].Code : '' });
        }
    }

    render() {
        if(!!!this.props.show) {
            return <React.Fragment />;
        }

        const usedCoupons = this.props.Coupons ? this.props.Coupons : [];
        const appliedCoupons = usedCoupons.map(c => {
            var key = "appliedCoupons" + c.Code;
            return (
                <div class="summary-coupon d-flex justify-content-between" key={key}>
                    <label class="coupon">{c.Code}</label>
                    {c.Discount && <span class="coupon currency-amt">{c.Discount}</span>}
                    <a class="fas fa-align-right fa-times-circle color-red" onClick={() => { this.removeCoupon(c.Code) }}></a>
                </div>
            );
        });

        return (
          <CheckoutSection label={this.props.isExpanded ? translateResourceString("/Checkout/Coupons/PartnerId") : null} toolTip={this.props.toolTip} hidden={false}>
              {
                this.props.isExpanded ?
                    <div className='coupon-wrapper bg-grey-light p-2'>
                         <div className="coupon-body bg-grey-light">
                            <div class="form-group">
                                <label class="text-sm fw-600">{translateResourceString("/Checkout/Coupons/PartnerId")}*</label>
                                <div class="coupon-container">
                                    <input
                                        id="newCouponCode"
                                        key="newCouponCode"
                                        type="text"
                                        className="coupon-input form-control col-6"
                                        value={this.state.newCouponCode}
                                        onChange={(e) => this.setState({ newCouponCode: e.target.value })}
                                        onKeyPress={(e) => { this.onKeyPress(e) }}
                                        placeholder={translateResourceString("/Checkout/Coupons/PartnerId")}
                                    />
                                    <button
                                        type="button"
                                        className="btn btn-blue btn-sm"
                                        onClick={() => { this.addCoupon() }}>
                                        {translateResourceString("/Checkout/Coupons/Save")}</button>
                                </div>

                            </div>
                        </div>
                    </div>
                :
                <div className='coupon-wrapper'>

                    <div className='bg-grey-light px-2 py-1 link-base'>
                        <a className='d-flex justify-content-between align-items-center' onClick={(e) => this.onClickChange(e)}>
                            <span className='d-flex'>
                                {translateResourceString("/Checkout/Coupons/Apply")} {translateResourceString("/Checkout/Coupons/PartnerId")}
                                <Tooltip text={this.props.toolTip} />
                            </span>
                        </a>
                    </div>


                    <Fade inProp={!this.state.isCollapsed}>
                        <div className="coupon-body bg-grey-light p-2">
                            <div class="form-group">
                                <label class="text-sm">{translateResourceString("/Checkout/Coupons/AddCouponCode")}</label>
                                <input
                                    id="newCouponCode"
                                    key="newCouponCode"
                                    type="text"
                                    className="coupon-input form-control mb-2"
                                    value={this.state.newCouponCode}
                                    onChange={(e) => this.setState({ newCouponCode: e.target.value })}
                                    onKeyPress={(e) => { this.onKeyPress(e) }}
                                    placeholder={translateResourceString("/Checkout/Coupons/PartnerId")}
                                />
                                <button
                                    type="button"
                                    className="btn btn-blue btn-sm mb-1"
                                    onClick={() => { this.addCoupon() }}>
                                    {translateResourceString("/Checkout/Coupons/Save")}</button>
                            </div>
                            {!!appliedCoupons.length && (
                                <div className="collapse-xs" id="appliedCoupons">
                                    {appliedCoupons}
                                </div>
                            )}
                        </div>
                    </Fade>
                </div>
                }

            </CheckoutSection>
        );
    }
}

CheckoutCoupon.propTypes = {
    Coupons: PropTypes.array.isRequired,
    CartItems: PropTypes.array,
    SelectedShippingOptionId: PropTypes.string
}

export default CheckoutCoupon
